import ServiceLanding from "@/pages/ServiceLanding";
import { Trees, Ruler, Scissors, Sprout, Grid3x3, Droplets } from "lucide-react";

const page = {
  slug: "landscaping",
  path: "/landscaping",
  crumb: "Landscaping",
  eyebrow: "Landscaping & Land Clearing · Melbourne",
  serviceType: "Landscaping",
  metaTitle: "Landscaping Services Melbourne | Site Cleanup Melbourne",
  metaDesc:
    "Landscaping quotes across Melbourne. Land clearing, levelling, turf removal, vegetation clearing and pre-build landscaping across Melbourne's growth corridors. Free quotes.",
  h1: "Landscaping & Land Clearing Melbourne",
  intro:
    "Site Cleanup connects you with trusted local landscapers across Melbourne for land clearing, block levelling, turf and vegetation removal, retaining wall preparation, drainage prep, pre-build landscaping and post-build tidy-ups. Whether you've just picked up the keys to a vacant block in one of the northern-growth estates, need your yard cleared for a new build or extension, or want a full end-of-project landscape restore, we match you with one vetted operator who knows your suburb. We service Epping, Craigieburn, Wollert, Donnybrook, Mernda, Tarneit, Clyde, Werribee and the broader Melbourne metro. Every quote is free, photo-based, GST-inclusive and returned within one business day — no obligation, no sharing your details with a list of contractors. Just one matched local who quotes on the exact scope you need.",
  cta: "Get a Free Landscaping Quote",
  cardsTitle: "Landscaping services we quote on",
  cardsSub: "From vacant-block clearing through to final turf and drainage prep — every stage of getting your land builder-ready or garden-ready.",
  cards: [
    { title: "Land Clearing", icon: Trees, desc: "Clear overgrown vegetation, trees, weeds and dumped debris from vacant blocks and neglected yards." },
    { title: "Block Levelling", icon: Ruler, desc: "Level uneven land, remove humps, and prepare a builder-ready pad before construction starts." },
    { title: "Vegetation Removal", icon: Scissors, desc: "Remove trees, shrubs, root balls and stubborn vegetation — coordinated machinery for larger jobs." },
    { title: "Pre-Build Landscaping", icon: Sprout, desc: "Prep your block so your builder can start on schedule — clearing, levelling, drainage and access." },
    { title: "Turf Removal", icon: Grid3x3, desc: "Strip existing turf ready for new landscaping, paving, artificial grass or a full garden redesign." },
    { title: "Drainage Prep", icon: Droplets, desc: "Prepare drainage runs, trenching and swales as part of a broader landscaping or pre-build package." },
  ],
  step3: "Landscaping starts",
  step3d: "Operator arrives on the agreed day with the machinery and crew needed to complete the scope — most residential jobs finish in 1–3 days.",
  faqTitle: "Landscaping questions we hear a lot",
  faq: [
    {
      q: "What landscaping services do you offer?",
      a: "Land clearing, block levelling, vegetation and tree removal, turf removal, pre-build site preparation, retaining wall prep and drainage prep. If it's earthworks or clearing, we can quote on it.",
    },
    {
      q: "Do I need council approval for land clearing in Melbourne?",
      a: "Depending on the size and location of the work, some clearing (especially of established trees or in overlay areas) may require council notification or a planning permit. We can advise during the quote process.",
    },
    {
      q: "How much does landscaping cost in Melbourne?",
      a: "Costs depend on block size, terrain, vegetation density and scope. Request a free photo-based quote and we'll come back with an accurate written price from a matched local operator.",
    },
    {
      q: "Can you clear my block before my builder starts?",
      a: "Yes — pre-build land clearing and levelling is one of our most common requests. Get in touch as early as possible so your builder's start date isn't delayed.",
    },
    {
      q: "What areas do you service?",
      a: "Epping, Craigieburn, Wollert, Donnybrook, Mernda, Tarneit, Clyde, Werribee and broader Melbourne metro. Regional Victoria available on request.",
    },
  ],
  finalTitle: "Free Melbourne landscaping quote.",
  finalSub: "Send us your address, a few photos and a quick description of the scope. We'll come back within one business day with a matched local operator and a firm written quote — GST included.",
};

export default function LandscapingPage() {
  return <ServiceLanding page={page} />;
}
